<template lang="pug">
    el-select(v-model="selectValue", filterable, remote, clearable, placeholder="Enter a school (optional)", :remote-method="getSchools", :loading="loading", no-data-text='No results for search term, search for complete words.')
        el-option(v-for="item in schoolOptions", :key="item.id", :label="item.name", :value="item.id")
            span(style="float: left") {{ item.name }}
            span(style="float: right; color: #8492a6; font-size: 13px") {{ item.address_postcode }} - {{ item.id }}
</template>

<script>
import gql from "graphql-tag";
import { cloneDeep } from "lodash";

export default {
	name: "SchoolSearch",
	props: {
		value: {
			type: String,
			default: undefined
		}
	},
	data() {
		return {
			selection: cloneDeep(this.value),
			loading: false,
			schoolOptions: []
		};
	},
	computed: {
		selectValue: {
			get() {
				return this.selection;
			},
			set(newValue) {
				this.selection = newValue;
				this.$emit("input", this.selection);
			}
		}
	},
	methods: {
		async getSchools(query) {
			if (!query) this.schoolOptions = [];

			this.loading = true;

			let Schools = await this.$apollo.query({
				query: gql`
					query SchoolSearch($term: String) {
						SchoolSearch(term: $term) {
							id
							name
							address_postcode
						}
					}
				`,
				variables: {
					term: query
				}
			});

			this.loading = false;
			this.schoolOptions = Schools.data.SchoolSearch;
		}
	}
};
</script>
